import { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import Button from "../../components/common/button/Button";
import Title from "../../components/common/title/Title";
import Input from "./../../components/common/inputs/Input";
import CategoriesSelect from "../../components/common/inputs/CategoriesSelect";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import { productValidation } from "../../utils/validations/prodcut/productValidation";
import SliderTageSelect from "../../components/common/inputs/SliderTageSelect";
import TextArea from "../../components/common/inputs/TextArea";
import Editor from "../../components/common/ck-editor/CkEditor";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import ProductImages from "./sub-components/product-images/ProductImages";
import ProductOption from "./sub-components/product-option/ProductOption";
import ProductFeature from "./sub-components/product-feature/ProductFeature";
import { PiXSquareFill } from "react-icons/pi";
import ProductsSelect from "../../components/common/inputs/ProductsSelect";

export default function Product() {
  const location = useLocation();
  const navigate = useNavigate();

  const [description, setDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");

  const formHandler = async (values, { resetForm }) => {
    if (values.hasGift && !giftProductSkus.length) {
      warningMessage("لطفا محصول هدیه را انتخاب کنید");
      return;
    }
    const body = {
      ...values,
      basePrice: Number(values.basePrice),
      buyPrice: Number(values.buyPrice),
      discount: Number(values.discount),
      weight: values.weight !== "" && values.weight !== undefined ? Number(values.weight) : undefined,
      categories,
      features,
      option: option ?? null,
      images,
      stock: option?.length ? undefined : Number(values?.stock),
      mainImage,
      discountType,
      sliderTags,
      seoKeywords,
      description,
      shortDescription,
      giftProductSkus: values.hasGift ? giftProductSkus : [],
    };
    if (
      discountType !== "percent" ||
      (discountType == "percent" && body.discount <= 100)
    ) {
      try {
        if (location?.state) {
          const response = await putApi({
            path: `admin/products/${location?.state?._id}`,
            body: JSON.stringify(body),
          });
          successMessage("محصول با موفقیت ویرایش شد");
        } else {
          const response = await postApi({
            path: "admin/products",
            body: JSON.stringify(body),
          });
          successMessage("محصول با موفقیت اضافه شد");
        }
        resetForm();
        setOption(null);
        setGiftProductSkus([]);
        reset();
        navigate("/product-list");
      } catch (error) {
        errorMessage(error?.response?.data?.errors[0].message);
      }
    } else {
      warningMessage("درصد تخفیف نمیتواند بیشتر از 100 باشد");
    }
  };

  const [option, setOption] = useState(null);
  const [features, setFeatures] = useState(null);

  const [images, setImages] = useState([]);
  const [mainImage, setMainImage] = useState("");
  const [discountType, setDiscountType] = useState(
    location.state?.discountType || "price"
  );
  const [oldOptions, setOldOptions] = useState([]);
  const [oldImages, setOldImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [oldFeatures, setOldFeatures] = useState([]);

  const [sliderTags, setSliderTags] = useState([]);
  const [giftProductSkus, setGiftProductSkus] = useState(location.state?.giftProductSkus || []);

  useEffect(() => {
    if (location.state) {
      setGiftProductSkus(location.state.giftProductSkus || []);
      setOldOptions(location.state.option || []);
      if (location.state.images?.length > 0) {
        let newImages = location.state.images.map((item) => {
          if (item == location.state.mainImage) {
            return { name: item, isMain: true };
          } else {
            return {
              name: item,
              isMain: false,
            };
          }
        });
        setOldImages(newImages);
        setImages(location?.state?.images || []);
      }
      if (location?.state?.seoKeywords) {
        setKeywords(location?.state?.seoKeywords);
      }
      if (location?.state?.mainImage) {
        setMainImage(location?.state?.mainImage || "");
      }
      if (location?.state?.option) {
        setOption(location?.state?.option || {});
      }
      if (location?.state?.features?.length) {
        setOldFeatures(location?.state?.features || []);
        setFeatures(location?.state?.features || []);
      }
      if (location?.state?.categories?.length) {
        setCategories(location?.state?.categories || []);
      }
      if (location?.state?.sliderTags?.length) {
        setSliderTags(location?.state?.sliderTags || []);
      }
    }
  }, [location.state]);
  const productOptionRef = useRef();

  const handle = (data) => {
    setOption(data);
  };

  const handleFeatures = (data) => {
    setFeatures(data);
  };

  const categoryRef = useRef();
  const imagesRef = useRef();
  const basePriceRef = useRef();
  const featuresRef = useRef();
  const sliderTagsRef = useRef();
  const buyPriceRef = useRef();

  const handleImages = (data) => {
    if (data?.length) {
      const mainImage = data.filter((item) => {
        return item.isMain == true;
      });
      setMainImage(mainImage[0].name);

      const allImages = data.map((item) => {
        return item.name;
      });
      setImages(allImages);
    } else {
      setMainImage("");
      setImages([]);
    }
  };

  const [newKeyword, setNewKeywords] = useState("");
  const [seoKeywords, setKeywords] = useState([]);

  const addSeoKeyWords = () => {
    if (newKeyword.length) {
      setKeywords((prev) => [...prev, newKeyword]);
      setNewKeywords("");
    } else {
      warningMessage("لطفا مقدار تگ را وارد کنید.");
    }
  };

  const deleteSeoKeywords = (index) => {
    let newTag = [...seoKeywords];
    newTag.splice(index, 1);
    setKeywords(newTag);
  };

  useEffect(() => {
    if (location.pathname == "/add-product") {
      reset();
    }
  }, [location.pathname]);

  const reset = () => {
    categoryRef.current.afterSubmit();
    productOptionRef.current.afterSubmit();
    imagesRef.current.afterSubmit();
    setOldImages([]);
    setOldOptions([]);
    basePriceRef.current.afterSubmit();
    featuresRef.current.afterSubmit();
    sliderTagsRef.current.afterSubmit();
    setGiftProductSkus([]);
  };
  const copyImagesUrlModal = useRef();

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 relative">
      <Title title={location.state ? "ویرایش محصول" : "افزودن محصول"} />
      <div className="mt-6">
        <Formik
          enableReinitialize
          initialValues={{
            name: location?.state?.name || "",
            status: location?.state?.status || "active",
            shortDescription: location?.state?.shortDescription || "",
            description: location?.state?.description || "",
            seoContent: location?.state?.seoContent || "",
            seoTitle: location?.state?.seoTitle || "",
            seoKeywords: location?.state?.seoKeywords || [],
            basePrice: location?.state?.basePrice || "",
            stock: location?.state?.stock || "",
            urlKey: location?.state?.urlKey || "",
            checkStock: location?.state?.checkStock || false,
            buyPrice: location?.state?.buyPrice || "",
            discount:
              location?.state?.discountType === "price"
                ? location?.state?.discountPrice
                : location?.state?.discountPercent || "",
            inventoryStatus: location?.state?.inventoryStatus || "available",
            brand: location?.state?.brand || "attarbashi",
            weight: location?.state?.weight ?? "",
            hasGift: location?.state?.hasGift || false,
          }}
          validationSchema={productValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام" label="نام" type="text" />
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت پایه
                  </label>
                  <CurrencyInput
                    placeholder="قیمت پایه"
                    name="basePrice"
                    id="basePrice"
                    ref={basePriceRef}
                    inputValue={formik.values.basePrice}
                    onChange={(e) => formik.setFieldValue("basePrice", e)}
                  />
                  {formik.errors.basePrice && formik.touched.basePrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.basePrice}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت خرید
                  </label>
                  <CurrencyInput
                    placeholder="قیمت خرید"
                    name="buyPrice"
                    id="buyPrice"
                    ref={buyPriceRef}
                    inputValue={formik.values.buyPrice}
                    onChange={(e) => formik.setFieldValue("buyPrice", e)}
                  />
                  {formik.errors.buyPrice && formik.touched.buyPrice ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.buyPrice}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تخفیف
                  </label>
                  <select
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"percent"}>درصد</option>
                    <option value={"price"}>قیمت</option>
                  </select>
                </div>
                <div>
                  <Input
                    name="discount"
                    placeholder="تخفیف"
                    label="تخفیف"
                    type="text"
                  />
                  {formik.errors.discount && formik.touched.discount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.discount}
                    </p>
                  ) : null}
                </div>

                <CategoriesSelect
                  label={"دسته بندی "}
                  oldCategory={location?.state?.categories}
                  ref={categoryRef}
                  onChange={setCategories}
                />
                <Select name="status" placeholder="وضعیت" label="وضعیت">
                  <option value={"active"}>فعال</option>
                  <option value={"pending"}>در حال بررسی</option>
                  <option value={"inactive"}>غیر فعال</option>
                </Select>

                <SliderTageSelect
                  label={"انتخاب تگ اسلایدر "}
                  oldSliderTags={sliderTags}
                  ref={sliderTagsRef}
                  onChange={setSliderTags}
                />

                <Select
                  name="inventoryStatus"
                  placeholder="موجودی"
                  label="موجودی"
                >
                  <option value={"available"}>موجود</option>
                  <option value={"unavailable"}>نا موجود</option>
                </Select>

                <Select
                  name="brand"
                  placeholder="برند"
                  label="برند"
                >
                  <option value={"attarbashi"}>عطارباشی</option>
                  <option value={"saboora"}>صبورا</option>
                </Select>

                {option ? null : (
                  <Input
                    name="stock"
                    placeholder="موجودی انبار"
                    label="موجودی انبار"
                    type="text"
                  />
                )}

                <Select
                  name="checkStock"
                  value={formik.values["checkStock"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "checkStock",
                      e.target.value === "true"
                    );
                  }}
                  placeholder="بررسی موجودی انبار"
                  label="بررسی موجودی انبار"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>

                <Input
                  name="weight"
                  placeholder="وزن (گرم)"
                  label="وزن (گرم)"
                  type="number"
                />

                <div className="flex flex-col gap-3">
                  {formik.values.hasGift && (
                    <ProductsSelect
                      label="محصولات هدیه"
                      oldProducts={giftProductSkus}
                      onChange={(skus) => setGiftProductSkus(skus)}
                    />
                  )}
                  <label className="flex items-center gap-2 cursor-pointer w-fit px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
                    <input
                      type="checkbox"
                      checked={formik.values.hasGift || false}
                      onChange={(e) =>
                        formik.setFieldValue("hasGift", e.target.checked)
                      }
                      className="w-4 h-4"
                    />
                    <span className="text-sm text-gray-700 dark:text-white">
                      این محصول هدیه دارد
                    </span>
                  </label>
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      کلمات کلیدی سئو
                    </label>
                    <input
                      value={newKeyword}
                      onChange={(e) => setNewKeywords(e.target.value)}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>
                  <div className="flex flex-col mt-8 gap-y-2">
                    <div className="">
                      <Button
                        onClick={addSeoKeyWords}
                        type="button"
                        text={"افزودن"}
                        color={"primary"}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-center flex-wrap gap-3">
                  {seoKeywords?.map((item, index) => {
                    return (
                      <button
                        type="button"
                        class="relative text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                      >
                        <PiXSquareFill
                          onClick={() => deleteSeoKeywords(index)}
                          size={26}
                          className={"absolute -top-2 -right-2 text-red-500"}
                        />
                        {item}
                      </button>
                    );
                  })}
                </div>
                <Input
                  name="urlKey"
                  placeholder="کلید url"
                  label="کلید url"
                  type="text"
                />
                <label>توضیحات کوتاه</label>
                <div className="flex flex-col gap-y-2">
                  <Editor
                    filed={"shortDescription"}
                    onChange={setShortDescription}
                  />
                </div>
                <TextArea
                  name="seoContent"
                  placeholder="محتوای سئو"
                  label="محتوای سئو"
                  type="text"
                />
                <TextArea
                  name="seoTitle"
                  placeholder="تیتر سئو"
                  label="تیتر سئو"
                  type="text"
                />
              </div>
              <div className="mt-4">
                <Button
                  type="button"
                  onClick={() => copyImagesUrlModal.current.showModal()}
                  text={"انتخاب عکس توضیحات"}
                  color={"primary"}
                  className="mb-3"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <Editor filed="description" onChange={setDescription} />
              </div>

              <div className="flex items-end mt-4">
                <button
                  onClick={() => productOptionRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                >
                  آپشن محصول
                </button>
                <button
                  onClick={() => imagesRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                >
                  عکس محصول
                </button>
                <button
                  onClick={() => featuresRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
                >
                  ویژگی محصول
                </button>
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="mt-6">
                  <Button
                    text={location.state ? "ویرایش" : "ایجاد محصول جدید"}
                    color={"success"}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <ProductImages
          ref={imagesRef}
          handleImages={handleImages}
          oldImages={oldImages}
        />
        <ProductOption
          ref={productOptionRef}
          handleOption={handle}
          optionData={oldOptions}
          productSku={location.state?.sku}
        />
        <ProductFeature
          ref={featuresRef}
          handleFeatures={handleFeatures}
          featureData={oldFeatures}
        />
        <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
      </div>
    </div>
  );
}
